import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Preloader from "./pages/offerings/Preloader"; // <-- Add this line

import Home from "./pages/Home";
import About from "./pages/About";
import HeroCarousel from "./components/HeroCarousel";
import Contact from "./pages/contact";
import Services from "./pages/services";
import PropertyRealEstate from "./pages/offerings/realestate";
import ContractManagement from "./pages/offerings/contractmanagement";
import ForeignCollaborations from "./pages/offerings/ForeignCollaborations";
import BusinessVentures from "./pages/offerings/BusinessVentures";
import CorporateLaw from "./pages/offerings/CorporateLaw";
import InformationTechnology from "./pages/offerings/InformationTechnology";
import JointVentures from "./pages/offerings/JointVentures";
import MSME from "./pages/offerings/MSME";
import StartupIndiaInitiatives from "./pages/offerings/StartupIndiaInitiatives";
import ScrollToTop from "./pages/offerings/scrolltop";
import Testi from "./pages/testemonial";
import DisclaimerModal from "./components/disclaimer";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`app-wrapper ${loading ? "loading" : ""}`}>
    {loading && <Preloader />}
    <div className="app-content">
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<><HeroCarousel /><Home /></>} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/realestate" element={<PropertyRealEstate />} />
        <Route path="/contract" element={<ContractManagement />} />
        <Route path="/foreign" element={<ForeignCollaborations />} />
        <Route path="/buisness" element={<BusinessVentures />} />
        <Route path="/corporate" element={<CorporateLaw />} />
        <Route path="/information" element={<InformationTechnology />} />
        <Route path="/joint" element={<JointVentures />} />
        <Route path="/msme" element={<MSME />} />
        <Route path="/startup" element={<StartupIndiaInitiatives />} />
        <Route path="/scroll" element={<ScrollToTop />} />
        <Route path="/scroll" element={<ScrollToTop />} />
        <Route path="/testimonial" element={<Testi />} />
        <Route path="/disclaimer" element={<DisclaimerModal />} />
        
      </Routes>
    </Router>
    </div>
    </div>
  );
}

export default App;
